import { createContext } from "react";
import defaultClient from "./defaultClient";
const DataClientContext = /*#__PURE__*/ createContext(defaultClient);
export default DataClientContext;

//# sourceMappingURL=DataClientContext.js.map